import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import GrayPanel from '../../components/GrayPanel';


class PersonalData extends React.Component {


  render() {
    // layout classes
    const leftCol = 'col-sm-2';
    const labelCol = 'col-sm-2';
    const inputCol = 'col-sm-6';
    const rightCol = 'col-sm-2';

    // really simple styles
    const labelStyle = { marginTop: '.5rem' };
    const rowStyle = { marginTop: '15px' };

    const formDict = {
      FirstName: {
        label: 'Imię',
        type: 'text',
      },
      LastName: {
        label: 'Nazwisko',
        type: 'text',
      },
      FullName: {
        label: 'Nazwa wnioskodawcy',
        type: 'text',
      },
      AddressCountry: {
        label: 'Kraj',
        type: 'text',
      },
      AddressVoivodeship: {
        label: 'Województwo',
        type: 'text',
      },
      AddressPrecint: {
        label: 'Powiat',
        type: 'text',
      },
      AddressDistrict: {
        label: 'Gmina',
        type: 'text',
      },
      AddressCity: {
        label: 'Miejscowość',
        type: 'text',
      },
      AddressStreet: {
        label: 'Ulica',
        type: 'text',
      },
      AddressFlat: {
        label: 'Numer lokalu',
        type: 'text',
      },
      AddressNumber: {
        label: 'Numer budynku',
        type: 'text',
      },
      AddressZipCode: {
        label: 'Kod pocztowy',
        type: 'text',
      },
      Email: {
        label: 'Email',
        type: 'email',
      },
      PhoneNumber: {
        label: 'Telefon',
        type: 'tel',
      },
      url: {
        label: 'Adres skrytki EPUAP',
        type: 'text',
      },
    };

    return (
      <GrayPanel title="Dane wnioskodawcy: ">
        {Object.keys(formDict).map((v, i) => {
          return (
            <div className="row mobile-row" key={i} style={rowStyle}>
              <div className={leftCol} />
              <div className={labelCol}>
                <label htmlFor={`personal-data-${i}`} style={labelStyle}>{formDict[v].label}</label>
              </div>
              <div className={inputCol}>
                <input
                  id={`personal-data-${i}`}
                  className="form-control"
                  type={formDict[v].type}
                  value={this.props.userData[v] ? this.props.userData[v] : ''}
                  disabled 
                />
              </div>
              <div className={rightCol} />
            </div>
          );
        })}
      </GrayPanel>
    )
  }
}


export default PersonalData;


// WEBPACK FOOTER //
// src/containers/PersonalData/index.jsx